import { FC, useEffect, useRef } from 'react';
import { SwiperClass, useSwiper } from 'swiper/react';
import Bga from './assets/bga.svg';

import './style.scss';

export const Background: FC = () => {
  const swiper = useSwiper();
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const $container = containerRef.current;
    if (!swiper || !$container) {
      return;
    }

    const onSlideNext = (swiper: SwiperClass) => {
      if (swiper.activeIndex === 1) {
        if ($container.classList.contains('anime-reverse')) {
          $container.classList.remove('anime-reverse');
          void $container.offsetWidth;
        }
        $container.classList.add('anime-forward');
      }
    };

    const onSlidePrev = (swiper: SwiperClass) => {
      if (swiper.activeIndex === 0) {
        if ($container.classList.contains('anime-forward')) {
          $container.classList.remove('anime-forward');
          void $container.offsetWidth;
        }
        $container.classList.add('anime-reverse');
      }
    };

    swiper.on('slideNextTransitionStart', onSlideNext);
    swiper.on('slidePrevTransitionStart', onSlidePrev);

    return () => {
      swiper.off('slideNextTransitionStart', onSlideNext);
      swiper.off('slidePrevTransitionStart', onSlidePrev);
    };
  }, [swiper]);

  return (
    <div className="background-wrap" ref={containerRef}>
      <div className="background">
        <div className="layer-0">
          <div className="layer-1">
            <div className="layer-1-position">
              <div className="layer-1-opacity">
                <div className="layer-1-rotation">
                  <div className="layer-1-content">
                    <Bga />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
